import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { DatePicker, DefaultButton, Dropdown, Panel, PrimaryButton, Stack, TextField } from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";
import { dbDate } from "../../Utilities/dbDate";
import NetGrossPicker from "../../Components/NetGrossPicker";

function EditAgreementProtocol(props) {
    const [user] = useContext(AuthContext);
    const [number, setNumber] = useState('');
    const [note, setNote] = useState('');
    const [contractor, setContractor] = useState('');
    const [contractors, setContractors] = useState([]);
    const [date, setDate] = useState('');
    const [net, setNet] = useState(0);
    const [vat, setVat] = useState(0);
    const [gross, setGross] = useState(0);

    const _submit = (e) => {
        e.preventDefault();
        const data = {number: number, note: note, contractor_id: contractor.key,
            net: net, gross: gross, vat: vat, date: dbDate(date)};
        fetch(`/api/agreement/protocol/${props.add.id}`, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='EditAgreementProtocol'>Edytuj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        const abortController = new AbortController();
        if (props.add) {
            setNumber(props.add.number);
            setNote(props.add.note);
            setContractor({key: props.add.contractor_id});
            setDate(props.add.date !== null ? new Date(props.add.date) : null);
            setNet(props.add.net_value);
            setVat(props.add.vat);
            setGross(props.add.gross_value);

            async function fetchContractors() {
                await fetch(`/api/contractor`, {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                        'Authorization': 'Bearer ' + user.token
                    }
                }).then(res => res.json())
                    .then(data => {
                        setContractors(data.map((item) => {
                            return {key: item.id, text: item.name};
                        }))
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
            fetchContractors();

        }
        return () => abortController.abort();
    }, [props.add, user.token])

    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Edytuj Protokół"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='EditAgreementProtocol'>
                <TextField required autoFocus label='Numer' value={number} onChange={(e) => setNumber(e.target.value || '')}/>
                <Dropdown
                    label="Wykonawca"
                    selectedKey={contractor ? contractor.key : undefined}
                    onChange={(e, item) => setContractor(item)}
                    placeholder="Wybierz z listy"
                    options={contractors}
                />
                <TextField multiline label='Notatka' value={note} onChange={(e) => setNote(e.target.value || '')}/>
                <DatePicker
                    label="Data"
                    isRequired={true}
                    placeholder="Wybierz datę..."
                    ariaLabel="Wybierz datę"
                    value={date}
                    onSelectDate={(e) => setDate(e || '')}
                />
                <NetGrossPicker net={net} setNet={setNet} gross={gross} setGross={setGross} vat={vat} setVat={setVat} />
            </form>
        </Panel>
    )
}

export default EditAgreementProtocol;